export default __webpack_public_path__ + "static/climate-environmental-justice-hero-596694074e6d1e2fcbea901a6575987b.webp";